import React, { memo } from 'react';
import { BoutiqueCalendarArrowIcon, BoutiqueCalendarTexts } from './boutique-calendar.constants';
import '@/assets/styles/views/boutique-classroom/boutique-calendar/boutique-calendar-toolbar.styles.scss';

interface Props {
	rangeLabel: string;
	onPreviousWeek: () => void;
	onNextWeek: () => void;
	onCurrentWeek: () => void;
}

export const BoutiqueCalendarToolbar: React.FC<Props> = memo(({ rangeLabel, onPreviousWeek, onNextWeek, onCurrentWeek }) => {
	return (
		<header className="boutique-calendar-toolbar">
			<div className="boutique-calendar-toolbar-group">
				<div className="boutique-calendar-toolbar-navigation">
					<button
						type="button"
						className="boutique-calendar-toolbar-arrow"
						title={BoutiqueCalendarTexts.previousWeek}
						onClick={onPreviousWeek}>
						<img
							src={BoutiqueCalendarArrowIcon.previous}
							alt=""
						/>
					</button>
					<button
						type="button"
						className="boutique-calendar-toolbar-arrow"
						title={BoutiqueCalendarTexts.nextWeek}
						onClick={onNextWeek}>
						<img
							src={BoutiqueCalendarArrowIcon.next}
							alt=""
						/>
					</button>
					<span className="boutique-calendar-toolbar-range">{rangeLabel}</span>
				</div>
			</div>
			<button
				type="button"
				className="boutique-calendar-toolbar-today"
				onClick={onCurrentWeek}>
				{BoutiqueCalendarTexts.todayButton}
			</button>
		</header>
	);
});

BoutiqueCalendarToolbar.displayName = 'BoutiqueCalendarToolbar';

export default BoutiqueCalendarToolbar;
